import { SpriteAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Sprite } from "pixi.js";
import { ReelsLayout } from "./ReelsModel";

interface ReelsBezelSpec {
    roundPixels: boolean
    reelBackground: SpriteAssetSpec
    reelDivider: SpriteAssetSpec
    reelFrameBottom: SpriteAssetSpec
    reelFrameLeft: SpriteAssetSpec
    reelFrameRight: SpriteAssetSpec
    reelFrameTop: SpriteAssetSpec
}

export class ReelsBezel extends View {
    protected readonly spec: ReelsBezelSpec;
    protected readonly backgrounds: Sprite[] = [];

    constructor(protected override services: GameServices, protected reelsLayout: ReelsLayout) {
        super(services);

        const { factory, resources } = services;

        this.spec = resources.getSpec(`reelBezel`);
        const roundPixels = this.spec.roundPixels;

        for (let i = 0; i < reelsLayout.reelCount; i++) {
            const bg = factory.createSprite(this.spec.reelBackground, this);
            bg.roundPixels = roundPixels;
            bg.position.x = reelsLayout.positions[i].x;
            this.backgrounds.push(bg);
        }
    }
}

export class ReelsBezelOverlay extends View {
    protected readonly dividers: Sprite[] = [];
    protected readonly frameBottom: Sprite;
    protected readonly frameLeft: Sprite;
    protected readonly frameRight: Sprite;
    protected readonly frameTop: Sprite;

    constructor(protected override services: GameServices, protected reelsLayout: ReelsLayout) {
        super(services);

        const { factory, resources } = services;

        const spec = resources.getSpec(`reelBezel`) as ReelsBezelSpec;
        const roundPixels = spec.roundPixels;

        for (let i = 0; i < reelsLayout.reelCount - 1; i++) {
            const div = factory.createSprite(spec.reelDivider, this);
            div.position.x = reelsLayout.positions[i].x + reelsLayout.symbolSize.width / 2.0 + reelsLayout.reelSpacing / 2.0;
            this.dividers.push(div);
            div.roundPixels = roundPixels;
        }
        this.frameBottom = factory.createSprite(spec.reelFrameBottom, this);
        const height = reelsLayout.symbolSize.height * reelsLayout.symbolCount / 2.0;
        const width = (reelsLayout.symbolSize.width * reelsLayout.reelCount + reelsLayout.reelSpacing * (reelsLayout.reelCount - 1)) / 2.0;
        this.frameLeft = factory.createSprite(spec.reelFrameLeft, this);
        this.frameRight = factory.createSprite(spec.reelFrameRight, this);
        this.frameTop = factory.createSprite(spec.reelFrameTop, this);
        this.frameBottom.y += height;
        this.frameLeft.x += -width;
        this.frameRight.x += width;
        this.frameTop.y += -height;
        this.frameBottom.roundPixels = roundPixels;
        this.frameLeft.roundPixels = roundPixels;
        this.frameRight.roundPixels = roundPixels;
        this.frameTop.roundPixels = roundPixels;
    }
}